import { html } from 'lit-element';

const DEFAULT_SIZE = '15';

export const icon = ({ cellData: { icon, width, height } }) => html`
  <fc-icon icon="${icon}" style="--fc-icon-size: ${width || height || DEFAULT_SIZE}px"></fc-icon>
`;
